import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { AdsPlans } from "../../api";
import { AdsPlanDataResponse, AdsPlanPageFactory, AdsPlanStatementChosen, AdsPlanStatementSignedPlan } from "../../interfaces";

export class AdsPageFactoryImpl implements AdsPlanPageFactory {
    create(
        subscriptionData: AdsPlanDataResponse | undefined,
        signedPlan?: AdsPlanStatementSignedPlan,
        handlerShowModalPayment?: (data: AdsPlanStatementChosen) => void
    ): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!subscriptionData?.success) return <NoDataComponent />
        return <AdsPlans plans={subscriptionData.response} signedPlan={signedPlan} handlerShowModalPayment={handlerShowModalPayment} />
    }
}